import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";

import img1 from "../assets/mukarjee logo.jpeg";
import img2 from "../assets/Pramount IT logo.jpeg";
import img3 from "../assets/samprada full logo.jpeg";
import img4 from "../assets/Shubha final logo.jpeg";
import img5 from "../assets/Ugale.jpeg";
import img6 from "../assets/mother india logo.jpeg";

import "swiper/css";
import "./ShowcaseSlider.css";

const ShowcaseSlider = () => {
  const logos = [
    img1, img2, img3, img4, img5, img6
  ];

  return (
    <section className="showcase-section">
      <div className="showcase-container">
        <div className="showcase-text">
          <h2>Show you care!</h2>
          <p>
            Join hundreds of corporates & offer parent care benefits
            for your employees.
          </p>
        </div>

        <div className="showcase-slider-wrap">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={20}
            loop={true}
            speed={2500}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
            }}
            breakpoints={{
              0: { slidesPerView: 2 },
              576: { slidesPerView: 3 },
              768: { slidesPerView: 4 },
              1024: { slidesPerView: 4.5 },
              1280: { slidesPerView: 5 },
            }}
            className="showcase-swiper"
          >
            {logos.map((logo, index) => (
              <SwiperSlide key={index}>
                <div className="showcase-logo-box">
                  <img src={logo} alt={`Partner Logo ${index + 1}`} />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default ShowcaseSlider;